import api from "../../../utilities/Interceptor";

const url = process.env.REACT_APP_API_KEY

export const getStops = (setStops: any, id_trazo: number, id_bitacora: number) => {
    api.get<{ POLITICA_SERVICIO: string }>(`${url}/maps/stops?id_trazo=${id_trazo}&id_bitacora=${id_bitacora}`)
        .then((res) => {
                setStops(res.data);
            }
        ).catch((error) => {
        console.log("error", error);
    })
}

